import React from "react";
import Group277 from "../Group277";
import Group278 from "../Group278";
import "./Property1Frame271.css";

function Property1Frame271(props) {
  const {
    rectangle30,
    moreThan,
    rectangle391,
    rectangle382,
    group277Props,
    group2781Props,
    group2782Props,
    group2783Props,
  } = props;

  return (
    <div className="bridal-slider">
      <div className="group-288">
        <div className="overlap-group-2">
          <img className="rectangle-30" src={rectangle30} />
          <div className="group-277 border-1px-black">
            <img className="more-than" src={moreThan} />
          </div>
          <Group277 src={group277Props.src} />
        </div>
        <div className="group-285">
          <div className="ellipse-38"></div>
          <div className="ellipse"></div>
          <div className="ellipse"></div>
        </div>
      </div>
      <div className="group-289">
        <Group278 />
        <div className="flex-col-1">
          <img className="rectangle-3" src={rectangle391} />
          <div className="group-286">
            <div className="ellipse-4"></div>
            <div className="ellipse-4-1"></div>
            <div className="ellipse"></div>
          </div>
        </div>
        <Group278 className={group2781Props.className} />
      </div>
      <div className="group-290">
        <Group278 className={group2782Props.className} />
        <div className="flex-col-2">
          <img className="rectangle-3" src={rectangle382} />
          <div className="group-287">
            <div className="ellipse-4"></div>
            <div className="ellipse-45"></div>
            <div className="ellipse-4-1"></div>
          </div>
        </div>
        <Group278 className={group2783Props.className} />
      </div>
    </div>
  );
}

export default Property1Frame271;
